export default function ImpressumPage() {
  return (
    <div className="bg-white" style={{ fontFamily: 'Inter, -apple-system, sans-serif' }}>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-gradient-to-b from-[#FAF9F7] to-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-semibold text-[#C4A962] uppercase tracking-[2px] mb-4 block">
              Rechtliches
            </span>
            <h1 className="text-4xl md:text-[52px] font-bold text-gray-900 leading-tight tracking-tight">
              Impressum
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-[800px] mx-auto px-4 md:px-8">
          <div className="prose prose-gray max-w-none">
            <div className="bg-[#FAF9F7] rounded-2xl p-8 mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4 mt-0">Angaben gemäß § 5 TMG</h2>
              <p className="text-gray-700 mb-0">
                <strong>asK-mi</strong><br />
                Kompetenzzentrum für menschliche Intelligenz<br /><br />
                c/o SteamWork<br />
                Roonstr. 23 a<br />
                76137 Karlsruhe<br /><br />
                E-Mail: <a href="mailto:we@ask-mi.com" className="text-[#A8923F] hover:underline">we@ask-mi.com</a>
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Verantwortlich für den Inhalt</h2>
              <p className="text-gray-700">
                alexander König<br />
                c/o SteamWork<br />
                Roonstr. 23 a<br />
                76137 Karlsruhe
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Haftung für Inhalte</h2>
              <p className="text-gray-600 leading-relaxed">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
                allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
                verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen 
                zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
                Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt 
                der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden 
                Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Haftung für Links</h2>
              <p className="text-gray-600 leading-relaxed">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
                verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
                Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche 
                Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht 
                zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Urheberrecht</h2>
              <p className="text-gray-600 leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
                Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
                Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. 
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte 
                Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
              </p>
            </div>

            <div className="bg-[#FAF9F7] rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4 mt-0">Streitschlichtung</h2>
              <p className="text-gray-600 leading-relaxed mb-0">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#A8923F] hover:underline ml-1">
                  https://ec.europa.eu/consumers/odr
                </a>
                <br /><br />
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
